import { config } from 'CONFIG';
import dayjs from 'dayjs';
import { Route } from 'vue-router';
import { AxiosError } from 'axios';
import { unfoldError } from './notice';
import { ESeriesCategory } from '@reolink-cloud/interface';

export const TB = 1024 * 1024 * 1024 * 1024;
export const GB = 1024 * 1024 * 1024;
export const MB = 1024 * 1024;
export const KB = 1024;
export const CREATE_ADDRESS_KEYS = [
    'line1',
    'line2',
    'city',
    'company',
    'country',
    'firstName',
    'lastName',
    'phone',
    'postalCode',
    'state',
    'vatNumber',
] as const;

export const isObject = ( o: any ): boolean => {

    return ( !( o instanceof Array ) && ( o instanceof Object ));

};

export const isNumeric = ( val: any ): boolean => {

    return !( val instanceof Array ) && ( val - parseFloat( val ) + 1 ) >= 0;

};

export const formatToFormUrlencoded = ( obj: Record<string, any> ): string => {

    if ( !isObject( obj )) {

        return '';

    }
    const ret: string[] = [];

    for ( const key in obj ) {

        if ( obj[ key ] !== null && obj[ key ] !== undefined ) {

            ret.push( `${key}=${encodeURIComponent( obj[ key ] )}` );

        }

    }

    return ret.join( '&' );

};

export const getCookie = ( name: string ): string|null => {

    if ( document.cookie.length > 0 ) {

        let start = document.cookie.indexOf( name + '=' );
        if ( start !== -1 ) {

            start = start + name.length + 1;
            let end = document.cookie.indexOf( ';', start );
            if ( end === -1 ) end = document.cookie.length;
            return unescape( document.cookie.substring( start, end ));

        }

    }

    return null;

};

export const setLocalStorageExpires = ({ key, value, expires }: { key: string; value: any; expires: number; }) => {

    if ( !value ) {

        localStorage.removeItem( key );

    } else {

        const _expires = expires * 24 * 60 * 60 * 1000 + Date.now();
        localStorage[key] = JSON.stringify({
            value: value,
            expires: _expires
        });

    }

};

export const getLocalStorageExpires = ( key: string ): any => {

    try {

        let obj;
        if ( !localStorage[ key ] ) {

            return null;

        } else {

            obj = JSON.parse( localStorage[ key ] );
            if ( !obj || obj.expires < Date.now()) {

                return null;

            } else {

                return obj.value;

            }

        }

    } catch ( e ) {

        console.error( e );
        return null;

    }

};

export const resolve2 = ( number: number ): string => {

    return number > 9 ? `${number}` : `0${number}`;

};

export const quickSort = ( arr: number[] ): number[] => {

    if ( arr.length <= 1 ) {

        return arr;

    }
    const index = Math.floor( arr.length / 2 );
    const temp = arr.splice( index, 1 );
    const numberTemp = Number( temp );
    const left: number[] = [];
    const right: number[] = [];

    for ( const item of arr ) {

        if ( Number( item ) < numberTemp ) {

            left.push( item );

        } else {

            right.push( item );

        }

    }

    return quickSort( left ).concat( temp, quickSort( right ));

};

let responseContentDispositionRegex;
export const downLoad = ( uri: string, name: string, responseContentDisposition: string ): void => {

    if ( typeof responseContentDisposition === 'string' ) {

        if ( !responseContentDispositionRegex ) {

            responseContentDispositionRegex = /(?:^|;\s*)filename=(\S+?)(?:;|$)/;

        }
        const matchedFilename = responseContentDisposition.match( responseContentDispositionRegex )?.[1];
        if ( matchedFilename ) {

            name = matchedFilename;

        }

    }
    try {

        const link = document.createElement( 'a' );
        link.href = uri;
        link.download = name;
        document.body.appendChild( link );
        link.click();
        document.body.removeChild( link );

    } catch ( err ) {

        console.error( err );

    }

};

export const getFromClient = ( name: string ): string => {

    if ( window.localStorage ) {

        const value = window.localStorage.getItem( name );
        return value ?? '';

    } else if ( document.cookie ) {

        return getCookie( name ) ?? '';

    } else {

        return '';

    }

};

export const setToClient = ( key: string, value: string, expires: number ): void => {

    if ( window.localStorage ) {

        window.localStorage.setItem( key, value );

    } else {

        document.cookie = `${key}=${value}; expires=${expires}; path=/`;

    }

};

export const clearClient = ( key: string ): void => {

    if ( window.localStorage ) {

        window.localStorage.removeItem( key );

    }
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT`;

};

// 获取检索文本前的文本

function getFrontString( mainStr: string, searchStr: string ): string | null {

    const foundOffset = mainStr.indexOf( searchStr );

    if ( foundOffset === -1 ) {

        return null;

    }

    return mainStr.substring( 0, foundOffset );

}

// 获取检索文本后的文本

function getEndString( mainStr: string, searchStr: string ): string | null {

    const foundOffset = mainStr.indexOf( searchStr );

    if ( foundOffset === -1 ) {

        return null;

    }

    return mainStr.substring( foundOffset + searchStr.length, mainStr.length );

}

export const getEndStr = ( mainStr: string, searchStr: string ): string|null => {

    return getEndString( mainStr, searchStr );

};

export const getFrontStr = ( mainStr: string, searchStr: string ): string|null => {

    return getFrontString( mainStr, searchStr );

};

// Go to 到 顶部
export const goTop = (): void => {

    let timer: number = -1;
    if ( timer ) {

        clearInterval( timer );

    }

    timer = window.setInterval( function() {

        const curHeight = document.documentElement.scrollTop || document.body.scrollTop;
        const now = curHeight;
        let speed = ( 0 - now ) / 7;

        speed = speed > 0 ? Math.ceil( speed ) : Math.floor( speed );

        if ( curHeight === 0 ) {

            clearInterval( timer );

        }

        document.documentElement.scrollTop = curHeight + speed;
        document.body.scrollTop = curHeight + speed;

    }, 30 );

};

export const getFeature = ( feature: string, enabled?: boolean ): boolean => {

    try {

        if ( !config.feature ) {

            return false;

        }
        if ( config.feature.enabled && enabled ) {

            return config.feature.enabled.includes( feature );

        }
        if ( config.feature.disabled && !enabled ) {

            return config.feature.disabled.includes( feature );

        }
        return false;

    } catch ( err ) {

        console.warn( 'error getFeature', err );
        return false;

    }

};

export const debounce = function( fn: any, delay: number ): any {

    let timer: number = 0;
    return function() {

        const context = this;
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        clearTimeout( timer );
        timer = window.setTimeout( function() {

            fn.apply( context, args );

        }, delay );

    };

};

export const delay = ( timeout: number ): Promise<boolean> => {

    return new Promise(( resolve ) => {

        window.setTimeout( function() {

            resolve( true );

        }, timeout );

    });

};

export const isInVisibleArea = ( selector: string ): boolean => {

    const oDiv = $( selector );
    const oWin = $( window );
    if ( oDiv.length > 0 ) {

        return !(( oWin.scrollTop()! > ( oDiv.offset()!.top + oDiv.outerHeight()! )) || (( oWin.scrollTop()! + oWin.height()! ) < oDiv.offset()!.top ));

    } else {

        return false;

    }

};

export const getQueryField = ( url: string ): Record<string, any> => {

    const index = url.indexOf( '?' );
    const queryString = index === -1 ? url : url.substr( index + 1 );
    const arr = queryString.split( '&' );
    const obj = {};
    for ( const item of arr ) {

        const fields = item.split( '=' );
        obj[ fields[ 0 ] ] = fields[ 1 ];

    }
    return obj;

};

export const isMobile = (): boolean => {

    return navigator.userAgent.includes( 'Mobile' );

};

export const encodeBase64 = ( string: string ): string => {

    return window.btoa( unescape( encodeURIComponent( string )));

};

export const decodeBase64 = ( string: string ): string => {

    return decodeURIComponent( escape( window.atob( string )));

};

export function roundToTwo( num: number ): string {

    return parseFloat( `${Math.round( num * 100 ) / 100}` ).toFixed( 2 );

}

export function roundToOne( num: number ): string {

    return parseFloat( `${Math.round( num * 100 ) / 100}` ).toFixed( 1 );

}

export function roundToInt( num: number ): string {

    return parseFloat( `${Math.round( num * 100 ) / 100}` ).toFixed( 0 );

}

export const unitTransfer = ( data: number, type = 'result' ): string => {

    let result: number;
    let unit = '';
    if ( data >= TB ) {

        result = data / TB;
        unit = 'TB';

    } else if ( data >= GB ) {

        result = data / GB;
        unit = 'GB';

    } else if ( data >= MB ) {

        result = data / MB;
        unit = 'MB';

    } else if ( data >= KB ) {

        result = data / KB;
        unit = 'KB';

    } else {

        result = data;
        unit = 'B';

    }
    if ( type === 'unit' ) {

        return unit;

    } else {

        if ( unit === 'KB' || unit === 'B' ) {

            return roundToInt( result );

        } else if ( unit === 'MB' ) {

            return roundToOne( result );

        } else {

            return roundToTwo( result );

        }

    }

};

export const calcFinalDataStrNormal = ( data: string | number ): string => {

    const finalData = typeof data === 'string' ? parseFloat( data ) : data;
    return `${unitTransfer( finalData )}${unitTransfer( finalData, 'unit' )}`;

};

export const timeCalculate = ( unit: string, amount: number ): number => {

    const day = 86400000;
    let seconds = 0;
    switch ( unit ) {

        case 'year':
            seconds = day * 365;
            break;
        case 'month':
            seconds = day * 30;
            break;
        case 'week':
            seconds = day * 7;
            break;
        case 'day':
            seconds = day;
            break;

    }
    return seconds * amount;

};
/*
    节流函数
    @param fn function
    @param delay number
    @return function
*/
export const throttle = <T extends ( ...args: any[] ) => any> (
    fn: T,
    delay: number
): T => {

    let timer: number | null;
    return function( this: ThisParameterType<T>, ...args: Parameters<T> ): void {

        const _this = this;

        if ( timer ) {

            return;

        }
        timer = window.setTimeout( function() {

            fn.apply( _this, args );
            timer = null; // 在delay后执行完fn之后清空timer，此时timer为假，throttle触发可以进入计时器

        }, delay );

    } as T;

};

export const isEmptyObject = ( obj: Record<string, any> ): boolean => {

    return Object.keys( obj ).length === 0 && obj.constructor === Object;

};

export const cutArray = <T extends any[]>( array: T, subLength: number ): T => {

    let index = 0;
    const newArr: T = [] as unknown as T;
    while ( index < array.length ) {

        newArr.push( array.slice( index, index += subLength ));

    }
    return newArr;

};

/**
 * 检查两个数组是否包含相同的元素，不考虑元素的顺序。
 *
 * @template T 元素类型限制为数字(number)或字符串(string)。
 * @param {T[]} arr1 第一个待比较的数组。
 * @param {T[]} arr2 第二个待比较的数组。
 * @returns {boolean} 如果两个数组包含完全相同的元素（无论顺序），返回true；否则返回false。
 *
 * @example
 * arraysEqualIgnoreOrder([1, 2, 3], [3, 2, 1]); // 返回: true
 * arraysEqualIgnoreOrder(['a', 'b', 'c'], ['c', 'b', 'a']); // 返回: true
 * arraysEqualIgnoreOrder([1, 2], [1, 2, 3]); // 返回: false
 */
export const arraysEqualIgnoreOrder = <T extends number | string> ( arr1: T[], arr2: T[] ): boolean => {

    const set1 = new Set( arr1 );
    const set2 = new Set( arr2 );

    return set1.size === set2.size && set1.size === arr1.length && set2.size === arr2.length &&
        set1.size === new Set( [...set1, ...set2] ).size;

};

/**
 * 生成一个该日期对应的凌晨0点0分的dayjs对象
 * @param timeStamp
 * @returns
 */
export const getNormalizeDayjs = ( rawTime?: Parameters<typeof dayjs>[0] ): dayjs.Dayjs => {

    let time = dayjs( rawTime );
    time = time.set( 'millisecond', 0 );
    time = time.set( 'second', 0 );
    time = time.set( 'minute', 0 );
    time = time.set( 'hour', 0 );

    return time;

};

/**
 * 将传入的byte单位的流量转化为合适的单位
 * @param dataSize
 */
export const calcFinalDataStr = ( dataSize: number, withB?: boolean, toFixed = 2, noUnit?: boolean ): string => {

    const units = ['B', 'K', 'M', 'G', 'T', 'P', 'E'];
    let finalNum = 0;
    let finalUnitIndex = 0;
    for ( let i = 0; i < units.length; ++i ) {

        const calcResult = dataSize / ( Math.pow( 1024, i ));
        if ( calcResult >= 1 ) {

            finalUnitIndex = i;
            finalNum = calcResult;

        } else {

            break;

        }

    }

    return parseFloat( finalNum.toFixed( toFixed )).toString() + ( noUnit ? '' : units[finalUnitIndex] ) + ( withB && finalUnitIndex !== 0 ? 'B' : '' );

};

export function desensitizeString( input: string|undefined ): string {

    if ( typeof input !== 'string' ) {

        return '';

    }

    const length = input.length;

    // 如果字符串长度小于等于 2，直接返回原字符串
    if ( length <= 2 ) {

        return input;

    }

    const startLength = Math.ceil( length * 0.3 ); // 取前30%的字符
    const endLength = Math.ceil( length * 0.2 );   // 取后20%的字符

    const start = input.slice( 0, startLength );
    const end = input.slice( -endLength );

    const maskedLength = length - startLength - endLength;
    const masked = '*'.repeat( maskedLength );

    return `${start}${masked}${end}`;

}
export function base64ToBase64Url( base64Str: string ): string {

    return base64Str.replace( /\+/g, '-' ).replace( /\//g, '_' ).replace( /=+$/, '' );

}

export function base64UrlToBase64( base64UrlStr: string ): string {

    const padded = base64UrlStr.length % 4 === 0 ? base64UrlStr : base64UrlStr + '==='; // 添加必要的填充
    return padded.replace( /-/g, '+' ).replace( /_/g, '/' );

}

/**
 * 计算竖向滚动条宽度
 * @link https://github.com/ElemeFE/element/blob/dev/src/utils/scrollbar-width.js
 */
export const getScrollBarWidth = ( forceUpdate: boolean = true ): number => {

    let scrollBarWidth: number = -999;
    return ((): number => {

        if ( scrollBarWidth !== -999 && !forceUpdate ) return scrollBarWidth;

        const outer = document.createElement( 'div' );
        outer.className = 'el-scrollbar__wrap';
        outer.style.visibility = 'hidden';
        outer.style.width = '100px';
        outer.style.position = 'absolute';
        outer.style.top = '-9999px';
        document.body.appendChild( outer );

        const widthNoScroll = outer.offsetWidth;
        outer.style.overflow = 'scroll';

        const inner = document.createElement( 'div' );
        inner.style.width = '100%';
        outer.appendChild( inner );

        const widthWithScroll = inner.offsetWidth;
        outer.parentNode!.removeChild( outer );
        scrollBarWidth = widthNoScroll - widthWithScroll;

        return scrollBarWidth;

    })();

};

/**
 * 转化object为qs字符串，支持值为数组，结果前面会带上`?`
 */
export const objectToQueryString = function ( obj?: object, prefix = '' ): string {

    if ( !obj ) {

        return '';

    }

    const queryString = Object.keys( obj )
        .filter( key => ![null, undefined].includes( obj[key] )).map( key => {

            const value = obj[key];
            const encodedKey = prefix ? `${prefix}[${encodeURIComponent( key )}]` : encodeURIComponent( key );

            if ( Array.isArray( value )) {

                return value
                    .map( arrayValue => `${encodedKey}=${encodeURIComponent( arrayValue )}` )
                    .join( '&' );

            } else if ( typeof value === 'object' && value !== null ) {

                return objectToQueryString( value, encodedKey );

            } else {

                return `${encodedKey}=${encodeURIComponent( value )}`;

            }

        })
        .join( '&' );

    return '?' + queryString;

};

export const getQueryParam = (
    route: Route,
    key: string,
    defaultValue?: string
): string[] => {

    const param = route.query[key];

    if ( param === undefined || ( Array.isArray( param ) && typeof param[0] !== 'string' )) {

        if ( defaultValue !== undefined ) {

            return [defaultValue];

        } else {

            return [];

        }

    }

    if ( typeof param === 'string' ) {

        return [param];

    }

    return param as string[];

};

/**
 * 将一个单元素数字转化为一个个chunk（每个chunk有多个单元数）
 * @param array
 * @param chunkSize
 * @returns
 */
export function splitArrayIntoChunks<T>( array: T[], chunkSize: number ): T[][] {

    return array.reduce(( result: T[][], item: T, index: number ) => {

        const chunkIndex = Math.floor( index / chunkSize );
        if ( !result[chunkIndex] ) {

            result[chunkIndex] = [];

        }
        result[chunkIndex].push( item );
        return result;

    }, [] );

}

export interface IBatchRequestOptions<TItem, TResult> {
    batchSize: number;
    concurrency?: number;
    createInitialResult: () => TResult;
    request: ( chunk: TItem[] ) => Promise<TResult>;
    merge: ( target: TResult, source: TResult ) => void;
}
/**
 * 批量请求，支持并发配置
 * @param items 请求的列表
 * @param options 配置
 * @returns 请求结果
 */
export async function batchRequest<TItem, TResult>(
    items: TItem[],
    options: IBatchRequestOptions<TItem, TResult>
): Promise<TResult> {

    const {
        batchSize,
        concurrency = 1,
        createInitialResult,
        request,
        merge
    } = options;

    const result = createInitialResult();

    if ( items.length === 0 ) {

        return result;

    }

    const chunks = splitArrayIntoChunks( items, batchSize );
    const workerCount = Math.min( Math.max( 1, concurrency ), chunks.length );
    let chunkIndex = 0;

    const runWorker = async (): Promise<void> => {

        while ( chunkIndex < chunks.length ) {

            const currentIndex = chunkIndex;
            chunkIndex += 1;
            const chunkResult = await request( chunks[currentIndex] );
            merge( result, chunkResult );

        }

    };

    await Promise.all( Array.from({ length: workerCount }, () => runWorker()));

    return result;

}

export function getErrorSymbol( e: unknown ): string {

    const symbol = ( e as AxiosError ).response?.data?.error?.symbol ?? '';
    return symbol;

}

export function checkOverflow({ clientWidth, clientHeight, scrollWidth, scrollHeight }: Element ): boolean {

    return scrollHeight > clientHeight || scrollWidth > clientWidth;

}

export async function requestWithErrorHandler( request: () => Promise<any>, symbolKeyMap?: Record<string, string> ): Promise<void> {

    try {

        await request();

    } catch ( e ) {

        const symbol = getErrorSymbol( e );
        if ( symbolKeyMap?.[symbol] ) {

            unfoldError( symbolKeyMap[symbol] );

        } else {

            unfoldError( 'errors.server_error' );

        }
        console.error( e );
        throw e;

    }

}

/**
 * 是否是云相关套餐
 * @param category
 * @returns
 */
export function isCloudPlan( category: unknown ): boolean {

    return [ESeriesCategory.CLOUD_STORAGE_DATA_PLAN, ESeriesCategory.CLOUD_STORAGE_PLAN, ESeriesCategory.CLOUD_RICH_NOTIFICATION_PLAN].includes( category as ESeriesCategory );

}

const URL_RESPONSE_DISPOSITION_REGEX = /(?:\?|&)response-content-disposition=([^&]+)/;
const CONTENT_DISPOSITION_FILENAME_REGEX = /(?:^|;\s*)filename=([^;]+)/;

/**
 * 从URL解析文件名
 * @param url - 包含响应头参数的URL
 * @param defaultName - 默认文件名
 * @returns 解析后的文件名（优先使用响应头中的文件名）
 */
export const parseFilename = ( url: string, defaultName: string ): string => {

    // 1. 从URL提取编码的响应头
    const dispositionMatch = URL_RESPONSE_DISPOSITION_REGEX.exec( url );
    if ( !dispositionMatch ) return defaultName;

    // 2. 解码响应头
    const decodedDisposition = decodeURIComponent( dispositionMatch[1] );

    // 3. 从响应头提取文件名
    const filenameMatch = CONTENT_DISPOSITION_FILENAME_REGEX.exec( decodedDisposition );
    return filenameMatch?.[1] ?? defaultName;

};

/**
 * 根据指定的属性或函数对对象数组进行分组
 *
 * @template T 数组元素的类型
 * @template K 分组键的类型，必须是字符串、数字或符号类型
 * @param {T[]} array 要分组的对象数组
 * @param {keyof T | ((item: T) => K)} keyOrFn 分组依据，可以是对象的属性名或返回分组键的函数
 * @returns {Record<K, T[]>} 分组后的对象，键为分组标识，值为该组的元素数组
 *
 * @example
 * // 根据对象属性分组
 * const users = [
 *   { name: 'Alice', age: 25, department: 'IT' },
 *   { name: 'Bob', age: 30, department: 'HR' },
 *   { name: 'Charlie', age: 25, department: 'IT' }
 * ];
 *
 * const groupedByDept = groupBy(users, 'department');
 * // 结果: { IT: [Alice, Charlie], HR: [Bob] }
 *
 * const groupedByAge = groupBy(users, 'age');
 * // 结果: { 25: [Alice, Charlie], 30: [Bob] }
 *
 * @example
 * // 根据自定义函数分组
 * const products = [
 *   { name: 'iPhone', price: 999 },
 *   { name: 'iPad', price: 599 },
 *   { name: 'MacBook', price: 1299 }
 * ];
 *
 * const groupedByPriceRange = groupBy(products, (item) =>
 *   item.price > 1000 ? 'expensive' : 'affordable'
 * );
 * // 结果: { affordable: [iPhone, iPad], expensive: [MacBook] }
 */
export const groupBy = <T, K extends string | number | symbol>(
    array: T[],
    keyOrFn: keyof T | (( item: T ) => K )
): Record<K, T[]> => {

    const result = {} as Record<K, T[]>;

    for ( const item of array ) {

        let groupKey: K;

        if ( typeof keyOrFn === 'function' ) {

            groupKey = keyOrFn( item );

        } else {

            groupKey = item[keyOrFn] as unknown as K;

        }

        if ( !result[groupKey] ) {

            result[groupKey] = [];

        }

        result[groupKey].push( item );

    }

    return result;

};

export const valueWithFallbacks = <T>( ...values: T[] ): T => {

    for ( const value of values ) {

        if ( value ) {

            return value;
        
        }
    
    }
    
    console.warn( 'All values are falsy in valueWithFallbacks:', values );
    
    return values[values.length - 1];

};

/**
 * 从错误中的metadata提取特定的信息,并输出位字符串格式
 * @param error unknown
 * @param key 需要提取的信息的键
 * @param fallbackValue 如果提取的信息不是字符串，返回的默认值
 * @returns 提取到的信息字符串，若不存在则返回默认值或空字符串
 */
export const extractErrorInfoToString = (
    error: unknown,
    key: string,
    fallbackValue?: string
): string => {

    const info = ( error as AxiosError )?.response?.data?.error?.metadata?.[key];

    return typeof info === 'string' ? info : ( fallbackValue ?? '' );

};
